import { createFileRoute } from '@tanstack/react-router';
import EmployeeGroups from '@/features/employee-groups';
import { ProtectedRoute } from '@/components/auth/protected-route';
import { Permissions } from '@/constants/roles-permissions';

export const Route = createFileRoute('/_authenticated/employee-groups')({
  component: EmployeeGroupsRoute,
});

function EmployeeGroupsRoute() {
  return (
    <ProtectedRoute requiredPermission={Permissions.EmployeeGroupView}>
      <EmployeeGroups />
    </ProtectedRoute>
  );
} 